import React, { useState } from "react";
import { Space } from "../../components/space/Space";
import { IFilterSelectProps } from "./definitions";
import { useFilterSheets } from "./hooks";
import escapeRegExp from "lodash/escapeRegExp";
import { useAppDispatch } from "../../app/store/hooks";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";
import Select, { SelectOption } from "@amzn/meridian/select";
import Column from "@amzn/meridian/column";

export const FilterSelectSearch: React.FC<IFilterSelectProps> = ({ selectOptions }) => {
    const dispatch = useAppDispatch();
    const { filterMap, handleFilterMapUpdate } = useFilterSheets();
    const [searchQuery, setSearchQuery] = useState();
    const searchRegExp = new RegExp(escapeRegExp(searchQuery), "i");
    const matchedOptions = selectOptions.options.filter(
        option => !searchQuery || searchRegExp.test(option.label)
    );

    return (
        <Box>
            <Text type={"h100"}> {selectOptions.label}</Text>
            <Space size={"xxs"} />

            <Select
                popoverMaxHeight={200}
                searchQuery={searchQuery}
                onSearch={setSearchQuery}
                value={filterMap.get(selectOptions.keyValue)?.value || ""}
                onChange={selectedValue =>
                    dispatch(
                        handleFilterMapUpdate({
                            type: "UPDATE",
                            filterKey: selectOptions.keyValue,
                            filterLabel: selectOptions.label,
                            value: selectedValue,
                        })
                    )
                }
                placeholder={selectOptions.placeholder}
                width={"100%"}
            >
                {matchedOptions.map(option => {
                    return <SelectOption value={option.value} label={option.label} />;
                })}
                {!matchedOptions.length ? (
                    <Column alignmentVertical="center" spacing="300" spacingInset="600">
                        <Text alignment="center">No results</Text>
                    </Column>
                ) : null}
            </Select>
        </Box>
    );
};
